import { useAppTheme } from "@hooks/useAppTheme";
import { Box, useDevice } from "@memorang/ui";
import ContentLoader from "react-native-easy-content-loader";
/* ----------------- Types --------------- */
import { Card, Divider } from "react-native-paper";

const flatContainer = { paddingHorizontal: 0, width: "100%" as const };
const flatAvatar = { marginRight: 12 };

const CardSkeleton = () => {
	const theme = useAppTheme();

	const { isMobile } = useDevice();

	const CardHeader = () => {
		return (
			<>
				<Box padding={16}>
					{/*@ts-ignore*/}
					<ContentLoader
						avatar
						aSize={40}
						title
						pRows={1}
						titleStyles={{ marginTop: 4, marginBottom: 8 }}
						paragraphStyles={{ marginVertical: 0 }}
						avatarStyles={flatAvatar}
						containerStyles={flatContainer}
					/>
				</Box>
				<Divider
					style={{
						backgroundColor: theme.colors.surfaceVariant,
					}}
				/>
			</>
		);
	};

	const showCardHeader = !isMobile;
	return (
		<Card>
			{showCardHeader && <CardHeader />}
			{[...new Array(10).keys()].map((item) => {
				return (
					<Box key={item} padding={16}>
						{/*@ts-ignore*/}
						<ContentLoader
							key={item}
							avatar
							title
							pRows={1}
							aSize={40}
							titleStyles={{ marginTop: 4, marginBottom: 8, height: 12 }}
							paragraphStyles={{ marginVertical: 0 }}
							avatarStyles={flatAvatar}
							containerStyles={flatContainer}
						/>
					</Box>
				);
			})}

			<Card.Actions>
				{/*@ts-ignore*/}
				<ContentLoader
					title={false}
					pRows={1}
					pHeight={34}
					paragraphStyles={{
						alignSelf: "flex-end",
						marginVertical: 0,
						width: 100,
					}}
					containerStyles={{ paddingHorizontal: 0 }}
				/>
			</Card.Actions>
		</Card>
	);
};

export default CardSkeleton;
